<template>
  <v-layout wrap v-if="editedID">
    <v-flex xs12 style="padding: 20px 10px 20px 20px">
      <v-autocomplete
        v-model="editedItem.TargetWorkspaceID"
        :items="allWorkspaces"
        outlined
        dense
        itemText="Name"
        itemValue="ID"
        label="Workpspace destino"
        hide-details
        :disabled="editedID !== 'new'"
      />
      {{editedID}}
    </v-flex>
    <v-progress-linear
      v-if="loadingSource"
      indeterminate
    />
    <v-flex xs12 style="padding: 10px"
      v-show="editedItem.TargetWorkspaceID && !loadingSource && !loadingTarget"
      v-for="item of sourceContentTypes"
      :key="item.ID"
    >
      <v-card
        style="padding: 10px;"
      >
        <small>{{item.Name}}</small>
        <br/>
        <v-autocomplete
          v-model="editedItem.SharedContents[item.ID]"
          :items="targetContentTypes"
          outlined
          dense
          itemText="Name"
          itemValue="ID"
          label="Content Type"
          hide-details
        />
      </v-card>
    </v-flex>
    <v-flex xs12 style="padding: 10px">
      <action-buttons
        v-if="editedItem"
        :id="editedItem.ID"
        :onDeleteItem="handleDelete"
        :onSaveItem="handleSave"
        :onClose="onClose"
        locale="es"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import api from '@/services/api'
import ActionButtons from '@/components/ActionButtons'
export default {
  name: 'WorkspaceShareContentForm',
  components: {
    ActionButtons,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    allWorkspaces: {
      type: Array,
      required: true,
    },
    editedID: {
      type: String,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    editedItem: {},
    sourceContentTypes: [],
    targetContentTypes: [],
    loadingSource: false,
    loadingTarget: false,
  }),
  computed: {
    shareContentTypes () {
      return ['media', 'message']
    },
  },
  watch: {
    editedID () {
      this.handleGetData()
    },
    workspaceID () {
      this.handleGetSourceContentTypes()
    },
    'editedItem.TargetWorkspaceID' () {
      this.handleGetTargetContentTypes()
    },
  },
  mounted () {
    this.handleGetData()
    this.handleGetSourceContentTypes()
    this.handleGetTargetContentTypes()
  },
  methods: {
    handleGetData () {
      if (this.editedID === 'new') {
        this.editedItem = { SharedContents: {} }
        return
      }
      
      api.getItem ('dviewcontent', `v1/system/share-content/`, this.editedID)
        .then(response => {
          if (!response) {
            this.editedItem = { SharedContents: {} }
            return
          }
          if (!response.SharedContents) response.SharedContents = {}
          else {
            const aux = {}
            for (const item of response.SharedContents) {
              console.log(item)
              aux[item.SourceContentID] = item.TargetContentID
            }
            response.SharedContents = aux
          }
          this.editedItem = response
          console.log('jhm response', response)
        })
    },
    handleGetSourceContentTypes () {
      this.sourceContentTypes = []
      if (!this.workspaceID) return
      this.loadingSource = true
      api.getItem (this.$route.meta.mainPath, 'v1/system/workspaces/', `${this.workspaceID}/info`, false)
        .then(response => {
          if (response && response.contentTypes) {
            const contentTypes = response.contentTypes
            this.sourceContentTypes = contentTypes.filter(x => this.shareContentTypes.indexOf(x.type) >= 0).map(item => {
              return {
                ID: item.id,
                Name: `${item.name.toUpperCase()} [${item.type}] :`,
              }
            })
          } else {
            this.sourceContentTypes = []
          }
          this.loadingSource = false
        })
    },
    handleGetTargetContentTypes () {
      this.targetContentTypes = []
      if (!this.editedItem.TargetWorkspaceID) return
      this.loadingTarget = true
      api.getItem (this.$route.meta.mainPath, 'v1/system/workspaces/', `${this.editedItem.TargetWorkspaceID}/info`, false)
        .then(response => {
          if (response && response.contentTypes) {
            const contentTypes = response.contentTypes
            this.targetContentTypes = contentTypes.filter(x => this.shareContentTypes.indexOf(x.type) >= 0).map(item => {
              return {
                ID: item.id,
                Name: `${item.name.toUpperCase()} [${item.type}]`,
              }
            })
          } else {
            this.targetContentTypes = []
          }
          this.targetContentTypes.unshift({ ID: null, Name: '' })
          this.loadingTarget = false
        })
    },
    handleSave () {
      const body = {
        SourceWorkspaceID: this.workspaceID,
        TargetWorkspaceID: this.editedItem.TargetWorkspaceID,
      }
      body.SharedContents = []
      for (const item of this.sourceContentTypes) {
        if (item.ID && this.editedItem.SharedContents[item.ID]) body.SharedContents.push({ SourceContentID: item.ID, TargetContentID: this.editedItem.SharedContents[item.ID]})
      }
      if (this.editedID === 'new') {
        api.addItem (this.$route.meta.mainPath, 'v1/system/share-content/', body)
          .then(response => {
            console.log(response)
            this.onClose(true)
          })
      } else {
        api.updateItem (this.$route.meta.mainPath, 'v1/system/share-content/', `${this.editedID}`, body)
          .then(response => {
            console.log(response)
            this.onClose(true)
          })
      }
    },
    handleDelete () {
      api.deleteItem (this.$route.meta.mainPath, 'v1/system/share-content/', `${this.editedID}`, {})
        .then(response => {
          console.log(response)
          this.onClose(true)
        })
    },
  },
}
</script>
